import React from 'react';
import { Container, Row, Col,Card , CardHeader,CardBody,FormInput,Button,
		Form,FormSelect,DatePicker } from "shards-react";
import PageTitle from "../common/PageTitle";
import FireFileUpload from '../FireFileUpload';
import firebase from '../../firebase';
import { AtomSpinner } from 'react-epic-spinners';
import is_empty_string from '../isEmptyString';
import AlertBox from '../AlertBox';
import alert from '../AlertStore';



export default class AddBankDeposit extends React.Component{
	constructor(props) {
	  super(props);
	
	  this.state = {loading:false,
	  				amount:null,
	  				description :null,
	  				type:'cash', //initial 
 	  				deposit_date : null,
	  				doc_link:null,
	  				doc_filename:null,
	  				};
	  this.addDeposit = this.addDeposit.bind(this);
	  this.resetState = this.resetState.bind(this);
	}

	resetState = () =>{
			this.setState({
					loading:false,
	  				amount:null,
	  				description :null,
	  				type:'cash',
	  				deposit_date : null,
	  				doc_link:null,
	  				doc_filename:null,
	  		});
	}

	addDeposit = () =>{
		if( is_empty_string(this.state.amount) || is_empty_string(this.state.description) || is_empty_string(this.state.type)  || is_empty_string(this.state.deposit_date===null?null:this.state.deposit_date.toLocaleDateString()) ){
				alert.showMessage("Kindly Enter All the Details","warning");
				return;
		}

		var data = {
			amount : parseInt(this.state.amount),
			description:this.state.description,
			type:this.state.type,
			doc_link : this.state.doc_link,
			date : (new Date(this.state.deposit_date)).toString(),
		};
		console.log(data);
		//return;
		var that = this;

		this.setState({loading:true});


		var func_ref = firebase.functions().httpsCallable('AddNewDeposit');

		func_ref(data).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully added!");
                        alert.showMessage("Deposit Added Successfully","success");
                        console.log(that.state);
                   }
                  else{
                        console.log(data.message);
                        alert.showMessage(data.message,"danger");
                  }
                  that.setState({loading:false});
                  that.resetState();

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  //var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  alert.showMessage("Unable to Add Deposit","danger");
        });

	}

	render(){
		return(
		<div>
			<AlertBox />
			 <Container fluid className="main-content-container px-4 pb-4">
        	
        		{/* Page Header */}
        		<Row noGutters className="page-header py-4">
              		<PageTitle sm="4" title="New Deposit" subtitle="Add" className="text-sm-left" />
        		</Row>



		    	<Col lg="12">
       				 <Card small className="mb-4">
          					<CardHeader className="border-bottom">
              						<h6 className="m-0">Add New Deposit</h6>
          					</CardHeader>
          					<CardBody className="p-2 pb-2" >
          						{
          							!this.state.loading &&
          							<Col>
          								<Form /*onSubmit={this.onSubmitHandler}*/>
          									<Row form>
          										<FormTextInput size="4" type="number" field_name="Deposit Amount" onChange={(evt)=>{this.setState({amount:evt.target.value})}}/>	 
          										<FormTextInput size="8" type="text" field_name="Description" onChange={(evt)=>{this.setState({description:evt.target.value})}}/>
          									</Row>
          									<Row form>
          										<Type onChange={(evt)=>{this.setState({type:evt.target.value})}}/>
          										<RefDate onChange={(date)=>{this.setState({deposit_date:new Date(date)})}}/>
                                <FileUpload path="Deposit/Doc" 
                                              field_name={"Doc Link"}
                                                link={this.state.doc_link}
                                                filename={this.state.doc_filename}
                                                  onChange={(url,name)=>{this.setState({doc_link:url,doc_filename:name})}}
                                                  remove={()=>{this.setState({doc_filename:null,doc_link:null})}} />
          									</Row>
          								

               								<SubmitButton onClick={this.addDeposit} />
               								
          								</Form>
          							</Col>
          						}
          						
          							{
           		 						(this.state.loading) &&
             							<AtomSpinner color="blue" style={{alignSelf: 'center',marginLeft: '40%',marginTop: '10%',marginBottom: '10%'}}/>
          							}
          						
          					</CardBody>
          			</Card>
          		</Col>


		    </Container>
		</div>

		)
	}
}


class SubmitButton extends React.Component{
	render(){
		return(
			<Row>
                						<Col lg="4"></Col>
                								<Col lg="4">
                									<Button onClick={this.props.onClick} style={{maxWidth: '100%',width:'100%',marginTop: '1%'}} size="md">
                										{"Add Deposit"}
                									</Button>
                								</Col>
                								<Col lg="4"></Col>
                						</Row>

		)
	}
}

//dont use for date
class FormTextInput extends React.Component{
	render(){
		return(
			 <Col md={this.props.size} className="form-group">
                  <label>{this.props.field_name}</label>
                  <FormInput
                  type={this.props.type}
                  placeholder={this.props.field_name}
                  onChange = {this.props.onChange}
                />

              </Col>
		)
	}
}


class FileUpload extends React.Component{
	render(){
		return(
				<Col md="4">
                   	 								<label htmlFor="fePassword">{this.props.field_name}</label>
                    								
                    								{ this.props.link===null &&
                    									<FireFileUpload path={this.props.path} 
                                    									update_url={(url,name)=>{this.props.onChange(url,name)}} />
                    								}
                    								{
                      									this.props.link!==null &&
                      									<div>
                          									<br />
                           									<Button theme="danger" onClick={()=>{this.props.remove()}}>Remove</Button>
                           									<h6 className="m-0">{this.props.filename}</h6>
                      									</div>
                    								}
               	</Col>
		)
	}
}

class RefDate extends React.Component{
	constructor(props) {
	  super(props);
	
	  this.state = {date:null};
	  this.handleDateChange = this.handleDateChange.bind(this);
	}

	handleDateChange(value){
		this.setState({date:new Date(value)});
		this.props.onChange(new Date(value));
	}

	render(){
		return(
				<Col md={"4"} className="form-group">
                  	<label>{"Deposit Date"}</label>
                  	<br />
                  	<DatePicker placeholderText="Ref Date"
                                  selected={this.state.date}
                                  onChange={this.handleDateChange}
                                  dropdownMode="select"
                                  className="text-center"
                                  />
              </Col>
		)
	}
}

class Type extends React.Component{



	render(){
		return(
				 <Col md={"4"} className="form-group">
                  		<label htmlFor="feEmailAddress">{"Type"}</label>
                  		<FormSelect onChange ={this.props.onChange}>
                  				<option value="cash">Cash</option>
                  				<option value="NEFT">NEFT</option>
                  				<option value="cheque">Cheque</option>
                  		</FormSelect>
              </Col>	
		)
	}
}
